import { Component, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { IUser } from '../../core/models/IUser';
import { UserService } from '../../core/services/user.service';
import { AddressPipe } from '../../shared/pipe/address.pipe';
import { DatePipe } from '@angular/common';
import { Router, RouterLink } from "@angular/router";
import { EditProfile } from "../../shared/components/profile/edit-profile/edit-profile";
import { environment } from "../../../environments/environment";
import { ICompany } from '../../core/models/ICompany';
import { CompanyAdd } from "../../shared/components/company/company-add/company-add";
import { CompanyService } from '../../core/services/company.service';
import { LogService } from '../../core/services/log.service';

@Component({
  selector: 'app-profile',
  imports: [
    MatCardModule,
    MatIconModule,
    MatTabsModule,
    DatePipe,
    AddressPipe,
    RouterLink,
    EditProfile
  ],
  templateUrl: './profile.html',
  styleUrl: './profile.scss'
})
export class Profile implements OnInit {

  user: IUser | null = null;
  isEditing = false;
  apiUrl = environment.apiUrl;
  addCompanyFormVisible = false;
  selectedPlan: string | null = null;
  isProcessing: boolean = false;

  constructor(
    private userService: UserService,
    private companyService: CompanyService,
    private router: Router,
    private logger: LogService
  ) { }

  ngOnInit(): void {
    this.userService.user$.subscribe(user => {
      this.user = user;
    });
  }

  editCompany(company: ICompany) {
    this.router.navigate(['/company', company._id, 'edit'], { state: { company } });
  }

  onSaveProfile(updatedUser: IUser) {
    if (!this.user) return;
    this.userService.editUser(this.user._id, updatedUser).subscribe(user => {
      this.user = user;
      this.isEditing = false;
    });
  }

  addCompany() {
    this.addCompanyFormVisible = true;
  }

  onCompanyAdded(newCompany: { data: ICompany, role: string }) {
    if (this.user) {
      this.user.companies.push(newCompany);
    }
    this.addCompanyFormVisible = false;
  }

  deleteCompany(companyId: string) {
    this.companyService.deleteCompany(companyId).subscribe(() => {
      if (
        this.user &&
        confirm("Êtes-vous sûr de vouloir supprimer cette société ? Cette action est irréversible.")
      ) {
        this.user.companies = this.user.companies.filter(c => c.data._id !== companyId);
      }
    });
  }

  onChangePassword() {
    this.router.navigate(['/forgot-password']);
  }

  selectPlan(plan: string): void {
    if (this.user?.userPlan?.planName === plan) {
      return;
    }
    this.selectedPlan = plan;
  }

  showUpgradeModal(): void {
    // Pré-sélectionner Premium si l'utilisateur est Free ou Basic
    this.selectedPlan = 'premium';

    const modalElement = document.getElementById('upgradeModal');
    if (modalElement) {
      const modal = new (window as any).bootstrap.Modal(modalElement);
      modal.show();
    }
  }

  confirmUpgrade(): void {
    if (!this.selectedPlan || this.selectedPlan === this.user?.userPlan?.planName) {
      return;
    }

    this.isProcessing = true;

    this.userService.upgradePlan(this.selectedPlan).subscribe({
      next: (res) => {
        if (res.requiresPayment && res.checkoutUrl) {
          window.location.href = res.checkoutUrl;
        }
      },
      error: (err) => {
        this.logger.error('Erreur upgrade: '+ err);
        this.isProcessing = false;
      }
    });
  }

}
